/* CoolDownPoint Premium - Custom JS */
(function(){
'use strict';
var NAMES=['Sarah M.','James K.','Emily R.','Michael T.','Jessica L.','David P.','Laura H.','Chris B.','Amanda W.','Ryan G.','Jennifer D.','Kevin S.','Michelle F.','Brian N.','Stephanie C.'];
var LOCS=['London, UK','Manchester, UK','Birmingham, UK','New York, US','Los Angeles, US','Chicago, US','Sydney, AU','Toronto, CA','Dublin, IE','Amsterdam, NL','Berlin, DE','Paris, FR'];
var TIMES=['just now','1 min ago','2 mins ago','3 mins ago','4 mins ago','5 mins ago'];
function r(arr){return arr[Math.floor(Math.random()*arr.length)]}

// Live purchase notifications
function createNote(){
  var img=document.querySelector('.product__media img');
  var src=img?img.src:'';
  var el=document.createElement('div');
  el.className='cdp-notification';
  el.innerHTML=(src?'<img src="'+src+'" class="cdp-notification-image" alt="">':'')+
    '<div class="cdp-notification-body"><div class="cdp-notification-title">'+r(NAMES)+' from '+r(LOCS)+'</div><div class="cdp-notification-subtitle">purchased this item &bull; '+r(TIMES)+'</div></div>'+
    '<button class="cdp-notification-close">&times;</button>';
  document.body.appendChild(el);
  requestAnimationFrame(function(){el.classList.add('show')});
  el.querySelector('.cdp-notification-close').addEventListener('click',function(){el.classList.remove('show');setTimeout(function(){el.remove()},400)});
  setTimeout(function(){if(el.parentNode){el.classList.remove('show');setTimeout(function(){el.remove()},400)}},6000);
}

function initNotes(){
  if(!document.body.classList.contains('template-product'))return;
  setTimeout(function(){createNote();setInterval(createNote,12000+Math.random()*13000)},6000);
}

// Countdown timer
function initCountdown(){
  var h=document.querySelector('.cdp-countdown-hours');
  var m=document.querySelector('.cdp-countdown-minutes');
  var s=document.querySelector('.cdp-countdown-seconds');
  if(!h||!m||!s)return;
  var end,stored=null;
  try{stored=localStorage.getItem('cdp-countdown-end')}catch(e){}
  if(stored){end=parseInt(stored,10);if(isNaN(end)||end<Date.now()){end=Date.now()+(2+Math.floor(Math.random()*4))*3600000;try{localStorage.setItem('cdp-countdown-end',end)}catch(e){}}}
  else{end=Date.now()+(2+Math.floor(Math.random()*4))*3600000;try{localStorage.setItem('cdp-countdown-end',end)}catch(e){}}
  function tick(){
    var d=Math.max(0,end-Date.now());
    h.textContent=String(Math.floor(d/3600000)).padStart(2,'0');
    m.textContent=String(Math.floor((d%3600000)/60000)).padStart(2,'0');
    s.textContent=String(Math.floor((d%60000)/1000)).padStart(2,'0');
    if(d<=0){end=Date.now()+(2+Math.floor(Math.random()*4))*3600000;try{localStorage.setItem('cdp-countdown-end',end)}catch(e){}}
  }
  tick();setInterval(tick,1000);
}

// Sticky mobile ATC
function initSticky(){
  if(window.innerWidth>749)return;
  var btn=document.querySelector('.product-form__submit');
  if(!btn||document.querySelector('.cdp-sticky-atc'))return;
  var p=document.querySelector('.price__sale .price-item--sale, .price-item--sale');
  var c=document.querySelector('.price__sale .price-item--regular, .price-item--regular');
  var bar=document.createElement('div');
  bar.className='cdp-sticky-atc';
  bar.innerHTML='<div class="cdp-sticky-atc-inner"><div>'+(p?'<div class="cdp-sticky-atc-price">'+p.textContent+'</div>':'')+(c?'<div class="cdp-sticky-atc-compare">'+c.textContent+'</div>':'')+'</div><button class="cdp-sticky-atc-btn">Add to Cart</button></div>';
  document.body.appendChild(bar);
  bar.querySelector('.cdp-sticky-atc-btn').addEventListener('click',function(){btn.scrollIntoView({behavior:'smooth',block:'center'});btn.click()});
  window.addEventListener('scroll',function(){bar.classList.toggle('visible',btn.getBoundingClientRect().bottom<0||btn.getBoundingClientRect().top>window.innerHeight)},{passive:true});
}

// Header shadow
function initHeader(){
  var h=document.querySelector('.shopify-section-header-sticky');
  if(!h)return;
  window.addEventListener('scroll',function(){h.classList.toggle('scrolled',window.scrollY>10)},{passive:true});
}

function init(){initNotes();initCountdown();initHeader();initSticky()}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
